<template>
  <div class="content-wrapper">
    <PageHeader :title="$t('map.tolldomains.dats.title')" />
    <div id="CCC-dat-panel" class="version-panel">
      <VersionPanel
        :dats="getCCCDats(masterAccount)"
        :alldats="getAllDats(masterAccount)"
        :masterAccount="masterAccount"
        :datType="'CCC'"
        @updateList="updateFilesList"
      />
    </div>
    <div id="EFC-dat-panel" class="version-panel">
      <VersionPanel
        :dats="getEFCDats(masterAccount)"
        :alldats="getAllDats(masterAccount)"
        :masterAccount="masterAccount"
        :datType="'EFC'"
        @updateList="updateFilesList"
      />
    </div>
    <div id="LAC-dat-panel" class="version-panel">
      <VersionPanel
        :dats="getLACDats(masterAccount)"
        :alldats="getAllDats(masterAccount)"
        :masterAccount="masterAccount"
        :datType="'LAC'"
        @updateList="updateFilesList"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator';
import { MasterAccountInfo } from 'ctp-user-auth-service';
import { store as userStore } from '@/store/modules/user/types';
import { DatV2 } from 'ctp-toll-domain';
import { store } from '@/store/modules/dats/types';
import PageHeader from '@/components/common/PageHeader/PageHeader.vue';
import VersionPanel from './components/VersionPanel.vue';

@Component({
  components: {
    PageHeader,
    VersionPanel
  }
})
export default class DatTypeContainer extends Vue {
  @userStore.Getter
  private getSelectedMasterAccount: MasterAccountInfo;

  @store.Action
  private fetchDats!: any;

  @store.Getter
  private getCCCDats: (master: MasterAccountInfo) => DatV2[];

  @store.Getter
  private getEFCDats: (master: MasterAccountInfo) => DatV2[];

  @store.Getter
  private getLACDats: (master: MasterAccountInfo) => DatV2[];

  @store.Getter
  private getAllDats: (master: MasterAccountInfo) => DatV2[];

  private masterAccount: MasterAccountInfo = {
    id: 0,
    name: '',
    vdoName: '',
    routeId: '',
    dsrcKeysEncryption: false
  };

  private updateFilesList() {
    this.fetchDats(this.masterAccount);
  }

  @Watch('getSelectedMasterAccount', { immediate: true, deep: true })
  private onMasterChange() {
    const account = this.getSelectedMasterAccount;
    if (account.name) {
      this.masterAccount = ({ ...this.masterAccount, ...account });
      this.fetchDats(this.masterAccount);
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles/dat-type-container.scss';
</style>
